import { useEffect, useState } from 'react';

const DEFAULT_HEIGHT = 800;

// Custom hook to get window dimensions with resize updates
export const useWindowDimensions = () => {
    const [dimensions, setDimensions] = useState({
        width: typeof window !== 'undefined' ? window.innerWidth : 1200,
        height: typeof window !== 'undefined' ? window.innerHeight : DEFAULT_HEIGHT,
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const updateDimensions = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        updateDimensions();

        window.addEventListener('resize', updateDimensions);

        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    return dimensions;
};
